import { Container, Option } from './styles'
import { FlagImage, LangLabel } from '../styles'
import { flags } from 'lang/flags'

interface LanguageItem {
  label: string
  id: keyof typeof flags
}

interface OptionsProps {
  items: Array<{ id: string; label: string }>
  isOpen: boolean
  selectedLang: string
  onSelectedChange(lang: string): void
}

function Options({
  items,
  isOpen,
  selectedLang,
  onSelectedChange,
}: OptionsProps) {
  return (
    <Container isOpen={isOpen}>
      {items.map((lang: LanguageItem) => (
        <Option
          key={lang.id}
          isSelected={lang.id === selectedLang}
          onClick={() => onSelectedChange(lang.id as string)}
        >
          <FlagImage alt="" src={flags[lang.id]} />
          <LangLabel>{lang.label}</LangLabel>
        </Option>
      ))}
    </Container>
  )
}

export default Options
